module.exports = __webpack_public_path__ + "Banner_PRESS.jpg?2c1bfa368f9df20c5d0a57c57b029bac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/press/Banner_PRESS.jpg
// module id = 269
// module chunks = 0